module.exports = __webpack_public_path__ + "static/scale-model-of-denton-texas-701822cc3a8b706713112782f0772ab9.png";